import { useDialog } from '@/hooks/useDialog';
import { PatientStackParamList } from '@/navigations/PatientStack';
import { useNavigation } from '@react-navigation/core';
import { StackNavigationProp } from '@react-navigation/stack';
import { Linking, View } from 'react-native';
import { Text } from '@/components/Text';
import { PrimaryButton } from '@/components/Button';
import { Links } from '@/config/links';
import { LicenseStatus } from '@/api/services/user';
import { styles } from './styles';
import { useChargebeeConsentNavigation } from '@/hooks/useChargebeeConsentNavigation';

export const LicenseExpired = ({
  licenseStatus,
  isDanger = false,
}: {
  licenseStatus?: LicenseStatus | null;
  isDanger?: boolean;
}) => {
  const { triggerNavigationOrConsent } = useChargebeeConsentNavigation();
  const { removeDialog } = useDialog();
  const { navigate } =
    useNavigation<StackNavigationProp<PatientStackParamList>>();

  const onDigaCodesPress = () => {
    removeDialog();
    navigate('DigaCodes');
  };

  const primaryLook = isDanger ? 'danger' : 'default';
  const secondaryLook = isDanger ? 'dangerOutlined' : 'secondary';

  return (
    <View style={styles.wrapper}>
      <Text style={styles.text}>
        {licenseStatus?.type === 'selfpay'
          ? 'Sie können die App wieder nutzen, wenn Sie eine neue Lizenz buchen oder einen neuen Rezeptcode von Ihrer gesetzlichen Krankenkasse einlösen.'
          : licenseStatus?.type === 'diga'
            ? 'Sie können die App wieder nutzen, wenn Sie einen neuen Rezeptcode von Ihrer gesetzlichen Krankenkasse einlösen oder eine neue Lizenz buchen.'
            : 'Sie können die App wieder nutzen, wenn Sie einen Rezeptcode von Ihrer gesetzlichen Krankenkasse einlösen oder eine Lizenz buchen.'}
      </Text>

      {licenseStatus?.type === 'trial' && (
        <Text style={[styles.text, styles.paragraph, { fontWeight: 'bold' }]}>
          Gesetzlich Versicherte erhalten die App kostenlos auf Rezept. Private
          Versicherungen erstatten in der Regel die Kosten zurück.{' '}
          <Text
            style={styles.link}
            onPress={() => Linking.openURL(Links.diga.href)}
          >
            Mehr Infos hier.
          </Text>
        </Text>
      )}

      <View style={styles.buttons}>
        <PrimaryButton
          label={
            licenseStatus?.type === 'selfpay'
              ? 'Neuen Rezeptcode einlösen'
              : licenseStatus?.type === 'trial'
                ? 'Lizenz buchen'
                : 'Neue Lizenz buchen'
          }
          look={secondaryLook}
          onPress={
            licenseStatus?.type === 'selfpay'
              ? onDigaCodesPress
              : triggerNavigationOrConsent
          }
        />
        <PrimaryButton
          label={
            licenseStatus?.type === 'selfpay'
              ? 'Neue Lizenz buchen'
              : licenseStatus?.type === 'trial'
                ? 'Rezeptcode einlösen'
                : 'Neuen Rezeptcode einlösen'
          }
          look={primaryLook}
          onPress={
            licenseStatus?.type === 'selfpay'
              ? triggerNavigationOrConsent
              : onDigaCodesPress
          }
        />
      </View>
    </View>
  );
};
